export default __webpack_public_path__ + "static/2050-0099b41edfe93f959092d47065dbc182.gif";